import { render } from "./MantBars.vue?vue&type=template&id=5c1c170d"
import script from "./MantBars.vue?vue&type=script&lang=js"
export * from "./MantBars.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Usuario\\filtros_frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__